import { Canvas, UIImage, UIText } from "./canvas";
import App from "../main";
import { SDKManager } from "./SDKManager";
import { LevelManager } from "./level-manager";
import InGameHUD from "./ingame-hud-scene";
import Game from "./game";
import { GAME_STATE } from "./Enums";

const gamesnacks = window.GameSnacks;

export default class ObjectiveScene extends Canvas {
    constructor() {
        super({
            key: 'Objective'
        });
    }

    public static instance: ObjectiveScene;
    private cheatCode: string = '';
    private readonly UNLOCK_CHEAT: string = 'unlock';
    private readonly LOCK_CHEAT: string = 'locked';

    init() {
        //console.log('Objective Scene');

    }

    private isEndless: boolean;

    private isAudioEnabled: boolean = true;

    // private sceneTitle: UIText;

    preload() {

        //this.isEndless = Utils.GetParameterByName('isEndless', window.location.search);
        ObjectiveScene.instance = this;
        // this.wakeUpWebAudioApi();
        this.isEndless = false;
        let loadingScreen = document.getElementById('loading-screen');
        let loaderText = document.getElementById('loader-text');
        let loaderBar = document.getElementById('loader-bar');

        if (!SDKManager.local) {
            gamesnacks.audio.subscribe((isAudioEnabled: boolean) => {
                this.isAudioEnabled = isAudioEnabled;
                if (isAudioEnabled) {
                    App.isMute = this.game.sound.mute = false;
                    this.wakeUpWebAudioApi();
                    Game.crowdAmbience.play();

                } else {
                    App.isMute = this.game.sound.mute = true;
                }
            });
        }
        SDKManager.onGamePause(this.onGamePause.bind(this));
        SDKManager.onGameResume(this.onGameResume.bind(this));

        let item = document.getElementById('item');

        loadingScreen.classList.remove('hide');

        this.load.on('progress', function (value) {
            let percent = Math.floor((value * 100)) + "%"
            loaderBar.style.width = percent;
            loaderText.innerText = percent
        });

        this.load.on('fileprogress', function (file) {
            item.innerText = "Loading";//file.src;

        });

        this.load.on('complete', function () {
            loadingScreen.classList.add('hide');
        });

        this.load.json('objectiveTexts', 'ui/objectiveTexts.json');
        this.load.json('objectiveCanvas', 'ui/objective-canvas.json');
        // this.load.multiatlas('game-ui', 'ui/game-ui.json', 'ui');
    }

    public onGamePause() {
        App.isMute = this.game.sound.mute = true;
        this.game.events.emit('onPauseButton');
        this.scene.pause();
        console.log("Game Pause on objective scene")
    }
    public onGameResume() {
        this.checkAudioAfterAd();
        this.game.events.emit('onResumeButton');
        this.scene.resume();
        console.log("Game Resume")
    }
    public checkAudioAfterAd() {
        // let isAudioEnabled = gamesnacks.audio.isEnabled();
        let isAudioEnabled = this.isAudioEnabled;
        if (isAudioEnabled) {
            App.isMute = this.game.sound.mute = false;
            this.wakeUpWebAudioApi();
        }
        else {
            App.isMute = this.game.sound.mute = true;
        }
    }

    private objectiveTexts: any;
    private objectiveSummaryPanel: UIImage;
    private objectiveUIObjects = Array<UIImage>();

    private leftArrow: UIImage;
    private rightArrow: UIImage;
    private exitButton: UIImage;

    create() {
        this.checkAudioAfterAd();
        super.setCanvas('objectiveCanvas');

        // //console.log("Scene Loaded");

        this.objectiveTexts = this.cache.json.get('objectiveTexts').objectiveTexts;

        this.objectiveUIObjects = new Array<UIImage>();

        for (let index = 1; index <= 50; index++) {
            var objectiveUI: UIImage = this.children.getByName('Objective (' + index + ')') as UIImage;
            this.initObjectiveUI(objectiveUI);
            this.objectiveUIObjects.push(objectiveUI);
            objectiveUI.setInteractive();
        }

        // LevelManager.getInstance().setLevelCompleted(0);

        this.initObjectivePanel();
        // this.sceneTitle.text = (this.isEndless ? 'ENDLESS MODE' : 'OBJECTIVE MOE');

        this.leftArrow = this.children.getByName('LeftArrowButton') as UIImage;
        this.rightArrow = this.children.getByName('RightArrowButton') as UIImage;
        this.exitButton = this.children.getByName('ExitButton') as UIImage;

        this.exitButton.visible = true;

        this.input.keyboard.on('keydown', this.handleKeyInput, this);

        ////console.log(this.exitButton);

        this.leftArrow.on('pointerup', this.leftArrowClick.bind(this));
        this.rightArrow.on('pointerup', this.rightArrowClick.bind(this));
        this.exitButton.on('pointerup', this.exitButtonClick.bind(this));

        this.currentPage = 1;

        this.events.on('wake', () => {
            this.updateLockIcons();
            this.showPage(this.currentPage);
        });
        this.updateLockIcons();
        this.showPage(this.currentPage);

        if (this.isEndless) {
            //this.showPage(-1);
            //this.showSummaryPanel();
            //this.hideSummaryPanel();

            this.scene.sleep('Objective');
            this.scene.launch('Game', { 'ObjectiveIndex': this.selectedIndex });
        } else {
            this.showPage(1);
        }


    }

    private watchAdTimer: Phaser.GameObjects.Graphics;

    public wakeUpWebAudioApi() {
        if ((this.game.sound as any).context.state === 'suspended') {
            (this.game.sound as any).context.resume();
        }
    }

    public updateLockIcons() {
        const levelManager = LevelManager.getInstance();
        const highestCompletedLevel = levelManager.getHighestCompletedLevel();
        //console.log('highestCompletedLevel: ', highestCompletedLevel);

        this.objectiveUIObjects.forEach((objectiveUI, index) => {
            const levelNumber = index + 1;  // Assuming levels start from 1
            const isUnlocked = this.isLevelUnlocked(levelNumber);

            if (objectiveUI["lockIcon"]) {
                objectiveUI["lockIcon"].visible = !isUnlocked;
            }

            if (levelNumber <= highestCompletedLevel) {
                objectiveUI["tickIcon"].visible = true;
            } else if (isUnlocked) {
                objectiveUI["tickIcon"].visible = false;
            } else {
                objectiveUI["tickIcon"].visible = false;
            }
        });
    }

    private leftArrowClick() {
        if (this.currentPage > 1) {
            this.showPage(this.currentPage - 1);
        }
    }

    private rightArrowClick() {
        if (this.currentPage < this.totalPages) {
            this.showPage(this.currentPage + 1);
        }
    }

    private exitButtonClick() {
        console.log("Interstitial ad")
        SDKManager.interstitialAdCallback(
            "next", "interstitial",
            this.beforeAd.bind(this), this.afterAd.bind(this),
            this.adBreakDone.bind(this));
        // setTimeout(() => {
        this.hideSummaryPanel();
        this.scene.sleep("Objective");
        if (this.scene.isSleeping("MenuScene")) {
            this.scene.wake("MenuScene");
        } else {
            this.scene.launch("MenuScene");
        }
        // }, 2000);
    }

    public beforeAd() {
        App.isMute = this.game.sound.mute = true;
    }

    public afterAd() {
        Game.instance.checkAudioAfterAd();
    }

    adBreakDone(placementInfo: any) {
        console.log("placement info", placementInfo);

    }

    private selectedIndex = -1;
    private selectedIcon: UIImage;

    private objectiveClick(target) {
        let levelNumber = target["objectiveIndex"] + 1;
        if (this.isLevelUnlocked(levelNumber)) {
            this.selectedIndex = target["objectiveIndex"];
            this.selectedIcon = target;
            this.showPage(-1);
            this.showSummaryPanel();
        }
    }

    private currentPage: number = 1;
    private totalPages: number = 4;

    private panelCloseButtonClick() {
        this.showPage(this.currentPage);
        this.hideSummaryPanel();
    }

    private playButtonClick() {
        console.log("Play")
        Game.gameState = GAME_STATE.GAME;
        let levelNumber = this.selectedIndex;
        if (this.isLevelUnlocked(levelNumber)) {
            this.showPage(-1);
            this.hideSummaryPanel();

            this.scene.sleep('Objective');
            this.scene.wake("InGameHUD");
            if (this.scene.isSleeping('Game')) {
                this.scene.wake('Game', { 'ObjectiveIndex': this.selectedIndex });
            } else {
                this.scene.launch('Game', { 'ObjectiveIndex': this.selectedIndex });
            }
            //console.log('start game');
        }
    }

    private initObjectiveUI(objectiveUI: UIImage) {
        let levelManager = LevelManager.getInstance();
        let levelNumber = parseInt(objectiveUI.getChildTextByName("Text").text);
        objectiveUI['objectiveIndex'] = levelNumber - 1;
        objectiveUI['indexText'] = objectiveUI.getChildTextByName('Text');
        objectiveUI['stumps01'] = objectiveUI.getChildImageByName('Stumps01');
        objectiveUI['stumps02'] = objectiveUI.getChildImageByName('Stumps02');
        objectiveUI['stumps03'] = objectiveUI.getChildImageByName('Stumps03');

        objectiveUI['show'] = (() => {
            objectiveUI['visible'] = true;
            objectiveUI['indexText'].visible = true;
            objectiveUI["lockIcon"].visible = !this.isLevelUnlocked(levelNumber);
            objectiveUI["tickIcon"].visible = this.isLevelCompleted(levelNumber);
            // objectiveUI['stumps01'].visible = true;
            // objectiveUI['stumps02'].visible = true;
            // objectiveUI['stumps03'].visible = true;
        });
        objectiveUI['hide'] = (() => {
            objectiveUI['visible'] = false;
            objectiveUI['indexText'].visible = false;
            objectiveUI["lockIcon"].visible = false;
            objectiveUI["tickIcon"].visible = false;
            // objectiveUI['stumps01'].visible = false;
            // objectiveUI['stumps02'].visible = false;
            // objectiveUI['stumps03'].visible = false;
        });

        objectiveUI.setInteractive();
        objectiveUI.on('pointerdown', this.objectiveClick.bind(this, objectiveUI));
        objectiveUI["stumps01"].visible = false;
        objectiveUI["stumps02"].visible = false;
        objectiveUI["stumps03"].visible = false;
        ////console.log (objectiveUI);

        objectiveUI['indexText'].depth = 5;
        this.createLockAtLocation(objectiveUI);
        this.createTickAtLocation(objectiveUI);

        objectiveUI["lockIcon"].visible = !this.isLevelUnlocked(levelNumber);
        objectiveUI["tickIcon"].visible = this.isLevelCompleted(levelNumber);

    }

    private createLockAtLocation(objectiveUI: UIImage) {
        let originalLockIcon = this.children.getByName("LockIcon") as UIImage;
        if (originalLockIcon) {
            originalLockIcon.visible = false;
            let lockIconCopy = new UIImage(this, {
                name: `LockIcon_${objectiveUI["objectiveIndex"]}`,
                spriteName: 'new-lock',
                parentName: objectiveUI.name,
                pivot: { x: 0.5, y: 0.5 },
                anchorMin: { x: 0.5, y: 0.5 },
                anchorMax: { x: 0.5, y: 0.5 },
                scaleFactor: { x: 0.5, y: 0.5 },
                anchoredPosition: { x: 0, y: 0 },
                tint: "FFFFFF",
                alpha: originalLockIcon.alpha
            });
            lockIconCopy.setScale(originalLockIcon.scaleX, originalLockIcon.scaleY);

            lockIconCopy.x = objectiveUI.x + 4.5;
            lockIconCopy.y = objectiveUI.y;

            objectiveUI["lockIcon"] = lockIconCopy;
            // //console.log(objectiveUI["lockIcon"]);
            if (objectiveUI.childrenImages) {
                objectiveUI.childrenImages.push(lockIconCopy);
            } else {
                objectiveUI.childrenImages = [lockIconCopy];
            }
            this.add.existing(lockIconCopy);
        } else {
            console.error("Original LockIcon not found");
        }
    }

    private createTickAtLocation(objectiveUI: UIImage) {
        let originalTickIcon = this.children.getByName("TickIcon") as UIImage;

        if (originalTickIcon) {
            originalTickIcon.visible = false;
            let tickIconCopy = new UIImage(this, {
                name: `TickIcon_${objectiveUI["objectiveIndex"]}`,
                spriteName: 'new-tick',
                parentName: objectiveUI.name,
                pivot: { x: 0.5, y: 0.5 },
                anchorMin: { x: 0.5, y: 0.5 },
                anchorMax: { x: 0.5, y: 0.5 },
                scaleFactor: { x: 0.5, y: 0.5 },
                anchoredPosition: { x: 0, y: 0 },
                tint: "FFFFFF",
                alpha: originalTickIcon.alpha
            });

            tickIconCopy.setScale(originalTickIcon.scaleX, originalTickIcon.scaleY);

            tickIconCopy.x = objectiveUI.x;
            tickIconCopy.y = objectiveUI.y;

            objectiveUI["tickIcon"] = tickIconCopy;
            if (objectiveUI.childrenImages) {
                objectiveUI.childrenImages.push(tickIconCopy);
            } else {
                objectiveUI.childrenImages = [tickIconCopy];
            };

            this.add.existing(tickIconCopy);
        } else {
            console.error("Original TickIcon not found");
        }
    }

    private isLevelUnlocked(levelNumber: number) {
        let levelManager = LevelManager.getInstance();
        let highestCompletedLevel = levelManager.getHighestCompletedLevel();
        return levelNumber <= highestCompletedLevel + 1;
    }

    private isLevelCompleted(levelNumber: number) {
        let levelManager = LevelManager.getInstance();
        return levelManager.isLevelCompleted(levelNumber);
    }

    private showPage(pageIndex: number) {
        const levelsPerPage = 15;
        const totalLevels = 50;

        for (let index = 0; index < this.objectiveUIObjects.length; index++) {
            this.objectiveUIObjects[index]["hide"]();
        }

        switch (pageIndex) {
            case 1:
            case 2:
            case 3:
                const startIndex = (pageIndex - 1) * levelsPerPage;
                const endIndex = startIndex + levelsPerPage;
                for (let index = startIndex; index < endIndex; index++) {
                    this.objectiveUIObjects[index]["show"]();
                }
                this.leftArrow.visible = pageIndex !== 1;
                this.rightArrow.visible = true;
                this.currentPage = pageIndex;
                break;
            case 4:
                for (let index = 45; index < totalLevels; index++) {
                    this.objectiveUIObjects[index]["show"]();
                }
                this.leftArrow.visible = true;
                this.rightArrow.visible = false;
                this.currentPage = 4;
                break;
            default:
                this.leftArrow.visible = false;
                this.rightArrow.visible = false;
                break;
        }
    }

    private handleKeyInput(event: KeyboardEvent): void {
        // if (event.key === 'Enter') {
        //     //this.checkCheatCode();
        // } else if (event.key.length === 1) {  // Only add single characters
        //     this.cheatCode += event.key.toLowerCase();
        //     if (this.cheatCode.length > this.UNLOCK_CHEAT.length) {
        //         this.cheatCode = this.cheatCode.slice(-this.UNLOCK_CHEAT.length);
        //     }
        // }
    }

    //   private checkCheatCode(): void {
    //     if (this.cheatCode === this.UNLOCK_CHEAT) {
    //         LevelManager.cheatCommandToUnlockAll();
    //         this.updateLockIcons();
    //         this.showPage(this.currentPage);
    //         //console.log('All levels unlocked!');
    //         // Optionally, display a message to the user
    //         this.cheatCode = '';  // Reset the cheat code
    //     }
    //     else if(this.cheatCode === this.LOCK_CHEAT){
    //         LevelManager.cheatCommandToLockAll();
    //         // window.level = 2;
    //         this.updateLockIcons();
    //         this.showPage(this.currentPage);
    //         //console.log("All levels locked!");
    //         this.cheatCode = '';
    //     }
    //   }

    private initObjectivePanel() {
        this.objectiveSummaryPanel = this.children.getByName('ObjectiveSummary') as UIImage;
        // this.sceneTitle = this.children.getByName('Title') as UIText;
        this.objectiveSummaryPanel['title'] = this.objectiveSummaryPanel.getChildTextByName('TitleText');
        this.objectiveSummaryPanel['summary'] = this.objectiveSummaryPanel.getChildTextByName('SummaryText');
        this.objectiveSummaryPanel['objectiveIcon'] = this.objectiveSummaryPanel.getChildImageByName('ObjectiveIcon');
        this.objectiveSummaryPanel['playButton'] = this.children.getByName('PlayButton') as UIImage;
        this.objectiveSummaryPanel['closeButton'] = this.children.getByName('CloseButton') as UIImage;

        // Hide Panel
        this.objectiveSummaryPanel['hidePanel'] = (() => {
            this.objectiveSummaryPanel['visible'] = false;

            this.objectiveSummaryPanel['childrenImages'].forEach(element => {
                element.visible = false;
            });

            this.objectiveSummaryPanel['childrenTexts'].forEach(element => {
                element.visible = false;
            });

            this.objectiveSummaryPanel['playButton'].visible = false;
        }).bind(this.objectiveSummaryPanel);

        // Show Panel
        this.objectiveSummaryPanel['showPanel'] = ((hideCloseButton: boolean = true) => {
            this.objectiveSummaryPanel['visible'] = true;
            this.objectiveSummaryPanel['childrenImages'].forEach(element => {
                element.visible = true;
            });

            this.objectiveSummaryPanel['childrenTexts'].forEach(element => {
                element.visible = true;
            });
            this.objectiveSummaryPanel['playButton'].visible = true;

            this.objectiveSummaryPanel['closeButton'].visible = hideCloseButton;
        }).bind(this.objectiveSummaryPanel);


        this.objectiveSummaryPanel['hidePanel']();

        this.objectiveSummaryPanel['closeButton'].on('pointerdown', this.panelCloseButtonClick.bind(this));
        this.objectiveSummaryPanel['playButton'].on('pointerdown', this.playButtonClick.bind(this));
    }

    private showSummaryPanel() {
        ////console.log
        this.objectiveSummaryPanel['objectiveIcon'].setTexture(this.selectedIcon.texture, this.selectedIcon.frame.name);

        this.objectiveSummaryPanel['title'].text = this.objectiveTexts[this.selectedIndex].title.toUpperCase();
        this.objectiveSummaryPanel['summary'].text = this.objectiveTexts[this.selectedIndex].summary;
        this.objectiveSummaryPanel['showPanel']();
    }

    private hideSummaryPanel() {
        //console.log("Hide Summary Panel");
        this.objectiveSummaryPanel['hidePanel']();
    }
}